import { LayoutActions } from 'store/actions/layout';

export default {
  displayNavBar: (state = false, action) => (action.type === LayoutActions.SET_DISPLAY_NAVBAR
    ? action.payload : state),
  displayMenu: (state = false, action) => {
    switch (action.type){
      case LayoutActions.SET_DISPLAY_MENU:
        return action.payload;
      case LayoutActions.TOGGLE_DISPLAY_MENU:
        return !state;
      default:
        return state;
    }
  },
  headerElements: (state = {}, action) => {
    switch (action.type) {
      case LayoutActions.SET_HEADER_ELEMENTS:
        return action.payload
      default:
        return state;
    }
  },
};
